import axios from 'axios';
import config from '../../../config.json';
const env = process.env.REACT_APP_ENVIRONMENT || 'stage';
const BACKEND_URL = config.api[env];

import { getToken } from "../../models/auth"

export default function add_comment({ id, type, message }) {
  return axios.post(`${BACKEND_URL}/comments`, {
    id, type, message
  }, {
    headers: { Authorization: `Bearer ${getToken()}` },
  })
}
